<script setup lang="ts">
import { computed } from 'vue';
import { useHalFeatures } from '@apparatix/stores/useHalFeatures';
import type { HalConfig } from '@apparatix/types/HalOptions';
import { useUtilities } from '@apparatix/composables';

type Props = {
  /**
   * Disable if the user has any of the provided flags
   * Disabled flags take precedence over enabled flags
   */
  disableFor?: HalConfig | HalConfig[];
  /**
   * Disable for everyone UNLESS they have the provided flags
   * When an array is passed, the user must have all provided flags
   */
  enableFor?: HalConfig | HalConfig[];
}

const props = defineProps<Props>();

const store = useHalFeatures();

const { arrayHasValues } = useUtilities();

const shouldShow = computed(() => {
  const disabledFlags = Array.isArray(props.disableFor) ? props.disableFor : [props.disableFor];
  const enabledFlags = Array.isArray(props.enableFor) ? props.enableFor : [props.enableFor];

  if (!arrayHasValues(disabledFlags) && !arrayHasValues(enabledFlags)) {
    return true;
  }

  const shouldDisable = disabledFlags.some(config => store.hasConfig(config));
  if (shouldDisable) {
    return false;
  }

  return enabledFlags.every(config => store.hasConfig(config));
});
</script>
<template>
  <slot v-if="shouldShow" />
  <slot v-else name="fallback" />
</template>
